import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, IconButton, Typography } from '@mui/material'
import ResponsiveModalDrawerContainer from 'src/Elements/Utilities/ResponsiveModalDrawerContainer'
import { J2Multiply, K1Generic } from '@e3dc-react/icons'
import ReactMarkdown from 'react-markdown'
import { markdownComponents } from 'src/Libs/offline-mode/components/OfflineInstallationHelpModal'

const CUSTOM_XS_BREAKPOINT = 400

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    '&  .MuiDialog-paper, & .MuiDrawer-paper': {
      height: 'auto',
      padding: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        paddingTop: 0,
      },
    },
  },
  icon: {
    fontSize: 30,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(4),
    },

    [theme.breakpoints.down(CUSTOM_XS_BREAKPOINT)]: {
      gap: theme.spacing(1),
    },
  },
  markdown: {
    '& ul': {
      listStyleType: 'disc',
      paddingLeft: theme.spacing(3),
    },
    '& > p:last-of-type': {
      marginTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      overflowY: 'scroll',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
    },
    paddingTop: theme.spacing(4),
    maxHeight: '70%',
    [theme.breakpoints.down(CUSTOM_XS_BREAKPOINT)]: {
      fontSize: 14,
      marginBottom: theme.spacing(2),
    },
  },
}))

/**
 * This is a Modal gives more information about the active variable dynamic power price alert.
 */
const ActiveVariableDynamicPowerPriceAlertModal: React.FC<{ isVisible: boolean; handleClose: () => void }> = ({ isVisible, handleClose }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <ResponsiveModalDrawerContainer modalMaxWidth="sm" containerStyle={classes.containerStyle} isOpen={isVisible} onClose={handleClose}>
      <Box className={classes.header}>
        <Box display="flex" alignItems="center">
          <Typography variant="h2" mr={1}>
            {t('systemSettings.active-vdpp-alert-modal.title')}
          </Typography>
          <K1Generic className={classes.icon} />
          <IconButton onClick={handleClose} sx={{ marginLeft: 'auto', color: 'inherit', padding: 0 }}>
            <J2Multiply className={classes.icon} />
          </IconButton>
        </Box>
      </Box>
      <Box className={classes.markdown}>
        <ReactMarkdown components={markdownComponents}>{t('systemSettings.active-vdpp-alert-modal.info-text')}</ReactMarkdown>
      </Box>
    </ResponsiveModalDrawerContainer>
  )
}

export default ActiveVariableDynamicPowerPriceAlertModal
